'use strict';
var dialog = require('../../dialog'),
	util = require('../../util');

var zoomMediaQuery = matchMedia('(min-width: 768px)');

/**
 * @description Enables the zoom viewer on the product detail page
 * @param zmq {Media Query List}
 */
var loadZoom = function () {
	var $imgContainer = $('#pdpMain .primary-images-carousel.slick-initialized').length
						? $('#pdpMain .slick-current .product-primary-image') : $('#pdpMain .product-primary-image');
	if (!$imgContainer.length) {
		return;
	}
	var $imgZoom = $imgContainer.find('.primary-image');
	var hiresUrl = $imgZoom.attr('hires') || $imgZoom.attr('src');

	// reset view
	var $zoomImage =  $imgContainer.find('.zoomImg');
	$zoomImage.remove();
	$imgContainer.trigger('zoom.destroy').removeClass('zoom-active');

	// check for all conditions that allow zoom
	if ($imgZoom.length === 0 || dialog.isActive() || !zoomMediaQuery.matches ||
		!hiresUrl || hiresUrl === 'null' || hiresUrl.indexOf('noimagelarge') >= 0) {
		return;
	}

	// init zoom
	$imgContainer.zoom({
		url: hiresUrl,
		on: 'click',
		touch: true,
		onZoomIn: function() {
			$imgContainer.addClass('zoom-active');
		},
		onZoomOut: function() {
			$imgContainer.removeClass('zoom-active');
		},
	});

	// disable zoom on mouse-leave
	$imgContainer.off('mouseleave.zoom').on('mouseleave.zoom', function() {
		$(document).trigger('click.zoom');
	});
};

zoomMediaQuery.addListener(loadZoom);

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
var setMainImage = function (atts) {
	if (!atts) {
		return;
	}
	$('#pdpMain .primary-image').attr({
		src: atts.url,
		alt: atts.alt,
		title: atts.title,
		hires: atts.hires // url of big image
	});

	loadZoom();
};

/**
 * @description Replaces the images in the image container, for eg. when a different color was clicked.
 */
var replaceImages = function () {
	var $newImages = $('#update-images'),
		$imageContainer = $('#pdpMain .product-image-container');
	if ($newImages.length === 0) { return; }

	$imageContainer.html($newImages.html());
	$newImages.remove();
	loadZoom();
};

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
	if ($('#pdpMain').find('.product-primary-image').length < 2 || $('.quickview-dialog:visible').length) {
		loadZoom();
		return;
	}

	var primaryImagesCarousel = $('#pdpMain').find('.primary-images-carousel');
	primaryImagesCarousel.not('.slick-initialized').slick({
		arrows: false,
		dots: true,
		adaptiveHeight: true,
		responsive: [{
			breakpoint: 768,
			settings: {
				dots: false,
			}
		}]
	});
	// show all images only after slick inited to avoid layout shifts on load
	primaryImagesCarousel.find('.product-primary-image.hidden, .product-video.hidden').removeClass('hidden');

	var interactionDetected = false;
	primaryImagesCarousel.on('afterChange', function(event, slick, currentSlide) {
		// remove fixed size (prevents shifts on load) after first interaction
		if (!interactionDetected) {
			primaryImagesCarousel.removeClass('initial-size');
			$(this).find('.slick-list').css('height', '');
			interactionDetected = true;
		}
		$('.product-thumbnails').find('.thumb.selected, .video-thumb.selected').removeClass('selected');
		$('.product-thumbnails').children().eq(currentSlide).addClass('selected');
		loadZoom();
	});

	// trigger resize when image loaded to show slider height properly
	// as slick has issue of 1px display for not loaded images
	var carouselInterval = setInterval(() => {
		if (primaryImagesCarousel.find('img').get(0).complete) {
			$(window).trigger('resize');
			clearInterval(carouselInterval);
		}
	}, 100);

	// handle product thumbnail click event
	$('#pdpMain').on('click', '.product-thumbnails .thumb:not(.selected), .product-thumbnails .video-thumb:not(.selected)', function () {
		if ($('.product-video').length && $('.video-thumb').hasClass('selected')) {
			$('.product-video').trigger('pause');
		}
		// switch indicator
		$(this).closest('.product-thumbnails').find('.thumb.selected, .video-thumb.selected').removeClass('selected');
		$(this).addClass('selected');

		primaryImagesCarousel.slick('slickGoTo', $(this).index());

		if (util.viewport.isMobile() && $(window).scrollTop() > primaryImagesCarousel.offset().top) {
			var headerHeight = $('.stuckMenu').height();
			$('html, body').scrollTop(primaryImagesCarousel.offset().top - headerHeight - 20);
		}

		loadZoom();
	});

	loadZoom();

};
module.exports.loadZoom = loadZoom;
module.exports.setMainImage = setMainImage;
module.exports.replaceImages = replaceImages;
